import React from "react";
import { Tooltip } from "antd";
import Table from "@components/Table";
import CustomButton from "@components/customButton";
import EvaluationStatusProgressBar from "@components/EvaluationStatusProgressBar";
import { IJobEvaluationDataResponse } from "@/store/jobEvaluation/types";

interface SetStatusButtonProps {
  record: any;
  onClick: any;
}

const SetStatusButton: React.FC<SetStatusButtonProps> = ({
  record,
  onClick,
}) => {
  const handleSwitchModal = () => {
    onClick(record);
  };

  const key = record.status!;

  return (
    <CustomButton
      onClick={handleSwitchModal}
      btnName={
        key?.toUpperCase() === "OPEN"
          ? "Set Status"
          : key.toUpperCase() === "EVALUATED"
          ? "Evaluated"
          : "Completed"
      }
      customClasses={`shadow-lg ${
        key.toUpperCase() === "CLOSE" ? "!px-4" : ""
      }`}
    />
  );
};

interface JobCreationTableProps {
  data: any[];
  columns: any[];
  onRowClick?: (record: any) => any | void;
  locale?: any;
  isLoading?: boolean;
  page?: number;
  pagination?: boolean;
  onChangePage?: (page: number) => void;
  count?: number;
  scroll?: number;
  perUpdate?: any;
  perDelete?: any;
  user?: any;
  pageSize?: number;
}

function calculateFilledPercentage(data: any) {
  const total = Object.keys(data).length;

  const filled = Object.values(data).filter(
    val => val !== undefined && val !== null && val !== ""
  ).length;

  return ((filled / total) * 100).toFixed(2);
}

const JobCreationTableComponent: React.FC<JobCreationTableProps> = ({
  columns,
  data,
  onRowClick,
  pagination = false,
  isLoading,
  page = 1,
  count = 10,
  onChangePage,
  locale,
}) => {
  const status: any = {
    Evaluated: "Evaluated",
    Close: "Completed",
    Open: "In-Progress",
  };

  const tableColumns = [
    ...columns,
    {
      title: "Status",
      key: "status",
      align: "center",
      width: 100,
      sorter: (
        a: IJobEvaluationDataResponse,
        b: IJobEvaluationDataResponse
      ) => {
        const percentageA = calculateFilledPercentage(a);
        const percentageB = calculateFilledPercentage(b);

        return Number(percentageA) - Number(percentageB);
      },
      render: (record: any) => (
        <Tooltip title={status[record.status_display]}>
          <div className="cursor-default" style={{ width: "100%" }}>
            <EvaluationStatusProgressBar {...record} />
          </div>
        </Tooltip>
      ),
    },
  ];

  return (
    <Table
      columns={tableColumns}
      data={data}
      isLoading={isLoading}
      onRowClick={onRowClick}
      pagination={pagination}
      page={page}
      count={count}
      onChangePage={onChangePage}
      locale={locale}
      splitLastColumn={true}
      fixedColumnsCount={2}
    />
  );
};

export default JobCreationTableComponent;
